import { TFunction } from "i18n";
import { getPlayingAgeTitle } from "shared-utils";

function getPlayingAgePillText({
  t,
  playingAgeTextFrom,
  playingAgeTextTo,
}: {
  t: TFunction;
  playingAgeTextFrom?: string;
  playingAgeTextTo?: string;
}) {
  if (playingAgeTextFrom && playingAgeTextTo) {
    return t("common:search.filters.tagLabel.playingAge.range", {
      lower: playingAgeTextFrom,
      upper: playingAgeTextTo,
    });
  }

  if (playingAgeTextFrom) {
    return t("common:search.filters.tagLabel.playingAge.over", {
      value: playingAgeTextFrom,
    });
  }

  if (playingAgeTextTo) {
    return t("common:search.filters.tagLabel.playingAge.under", {
      value: playingAgeTextTo,
    });
  }
}

export default function getPlayingAgePillTitle({
  t,
  lowerRangeValue,
  upperRangeValue,
}: {
  t: TFunction;
  lowerRangeValue?: number;
  upperRangeValue?: number;
}) {
  const playingAge = getPlayingAgePillText({
    t,
    playingAgeTextFrom: getPlayingAgeTitle(t, lowerRangeValue),
    playingAgeTextTo: getPlayingAgeTitle(t, upperRangeValue),
  });

  return t("common:search.filters.tagLabel.playingAge", {
    playingAge,
  });
}
